import * as React from 'react';
import * as DTOS from "../../FeralScan.dtos";
import * as classNames from "classnames";
import { withTheme } from '../../common/withTheme';
import InternalClassificationLink from '../Framework/Common/Links/InternalClassificationLink';
import { LocalForm, Control } from 'react-redux-form';
import Loader from 'react-loaders';
import * as UserActionCreators from "../../actions/user.actions";
import * as LoginActionCreators from "../../actions/login.actions";

interface IUserProfileProps {
    className?: string;
    user: DTOS.User;
}

interface IUserProfileActions {
    emailOptOut: typeof UserActionCreators.emailOptOutRequest;
}

type LeaveProgramPropsAndActions = IUserProfileProps & IUserProfileActions;

interface ILeaveProgramState {
}

class LeaveProgram extends React.PureComponent<LeaveProgramPropsAndActions, ILeaveProgramState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            editMode: false
        }
    }


    onToggleOptOut() {
        this.setState({ editMode: false })
        this.props.emailOptOut(!this.props.user.emailOptOut);
    }

    render() {

        const { user } = this.props;

        const title = user.emailOptOut ? 'Rejoin Program (Start Receiving Emails)' : 'Leave Program (Stop Receiving Emails)'
        const body = user.emailOptOut ? `If you wish to be actively involved in platypus monitoring as a registered APMN participant, 
            please click the button provided below. This will let us know that you will be contributing to the program again and that 
            we can add you back to the APMN email contact list.` 
            : `If you no longer want to be actively involved in platypus monitoring as a registered APMN participant, please click the
                button provided below. This will let us know that we should no longer expect to receive sightings information from you,
                and we’ll also remove your name from the APMN email contact list. Of course, you can re-register as an active APMN
                member at any time in the future if you wish.`

        const linkLabel = user.emailOptOut ? 'Rejoin Program' : 'Leave program';
        const linkButtonType = user.emailOptOut ? 'btn-success' : 'btn-danger';

        return (
            <div className={classNames(this.props.className, "card")}>
                <div className="card-body">
                    <h4 className="card-title">{title}</h4>
                    <p className="card-text">
                        {body}
                    </p>
                    <button className={classNames(linkButtonType, "btn")} onClick={this.onToggleOptOut.bind(this)}>{linkLabel}</button>
                </div>
            </div>
        );
    }
}

export default withTheme<LeaveProgramPropsAndActions>(LeaveProgram);